<template>
  <footer class="footer">
    <div class="container">
      <div class="row align-items-center flex-row-reverse">
        <div class="col-lg-12 col-sm-12 mt-3 mt-lg-0 text-center" style="line-height: 20px;">
          <div style="color:#808080;font-size: 12px;">未经hiturnjob.com同意，不得转载本网站之所有招聘信息及作品 Copyright © 2021 Hiturn海豚人才网</div>
					<div style="color:#808080;font-size: 12px;">
						<a href="https://beian.miit.gov.cn"  style="color:#808080;text-decoration: underline;">鲁ICP备13030807号-2</a>
						<a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" style="margin-left: 30px;color:#808080;text-decoration: underline;"><img style="width:17px;height:17px;margin-right: 2px;" src="@/assets/gaba.png">鲁公网安备 37039002000313号</a>
					</div>
					<div style="color:#808080;font-size: 12px;">
						<a href="https://www.hiturnjob.com/yyzz.jpg" target="_blank" style="margin-left: 10px;color:#808080;text-decoration: underline;">电子营业执照</a>
						<a href="https://www.hiturnjob.com/rlzyfwxkz.jpg" target="_blank" style="margin-left: 10px;color:#808080;text-decoration: underline;">人力资源服务许可证</a>
						<a href="https://www.12321.cn/" target="_blank" style="margin-left: 10px;color:#808080;text-decoration: underline;">违法和不良信息举报专区</a>
						<!-- <a href="https://www.12389.gov.cn/clue_evilNotice.action" target="_blank" style="margin-left: 10px;color:#808080;text-decoration: underline;">全国涉黑涉恶违法犯罪线索举报</a> -->
					</div>
					<div style="color:#808080;font-size: 12px;">
						<span>企业服务热线：0533-8299788</span>
						<span style="margin-left: 10px;">投诉/未成年人举报热线：19905333944</span>
						<!-- <span style="margin-left: 10px;">淄博高新区人社中心监督电话：3580780</span> -->
						<!-- <span style="margin-left: 10px;">投诉电话：19905333944</span> -->
					</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue